import en_US from '../../date-picker/locale/en_US';
export default en_US;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/calendar/locale/en_US.js
// module id = 297
// module chunks = 0